// extracted by mini-css-extract-plugin
export default {"root":"CircularProgress_root__0yvXV","loadingAnimation":"CircularProgress_loadingAnimation__zXGxp"};